// Generated by OrchestKit Claude Plugin
// Created: 2026-10-04

import { formaterFcfa } from './montant.tsx';

/** Nombre entier (FCFA) en toutes lettres, français — jamais de décimale (RG-001). */
export function montantEnLettres(montant: number): string {
  const entier = Math.max(0, Math.round(montant));
  const lettres = entier === 0 ? 'zéro' : nombreEnLettres(entier);
  return `${lettres} (${formaterFcfa(entier).trim()}) francs CFA`;
}

const UNITES = ['', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf'];
const DIX_A_SEIZE = ['dix', 'onze', 'douze', 'treize', 'quatorze', 'quinze', 'seize'];
const DIZAINES = ['', '', 'vingt', 'trente', 'quarante', 'cinquante', 'soixante', 'soixante', 'quatre-vingt', 'quatre-vingt'];

/**
 * `terminal` = false quand ce nombre PRÉFIXE un « mille »/« million »/
 * « milliard » : « quatre-vingt mille », jamais « quatre-vingts mille » —
 * le 's' de « vingts »/« cents » ne se pose que si rien ne suit.
 */
function centaineEnLettres(n: number, terminal = true): string {
  const c = Math.floor(n / 100);
  const reste = n % 100;

  let texte = '';
  if (c > 0) texte += c === 1 ? 'cent' : `${UNITES[c] ?? ''} cent`;
  if (c > 1 && reste === 0 && terminal) texte += 's';

  if (reste === 0) return texte;
  if (texte !== '') texte += ' ';

  if (reste < 10) {
    texte += UNITES[reste] ?? '';
  } else if (reste < 17) {
    texte += DIX_A_SEIZE[reste - 10] ?? '';
  } else if (reste < 20) {
    texte += `dix-${UNITES[reste - 10] ?? ''}`;
  } else {
    const dizaine = Math.floor(reste / 10);
    const unite = reste % 10;
    const motDizaine = DIZAINES[dizaine] ?? '';
    const motUnite = UNITES[unite] ?? '';
    // 70-79 et 90-99 se disent « soixante-DIX-sept », « quatre-vingt-DIX-sept ».
    if (dizaine === 7 || dizaine === 9) {
      const finale = unite < 7 ? (DIX_A_SEIZE[unite] ?? '') : `dix-${motUnite}`;
      texte += `${motDizaine}-${finale}`;
    } else if (unite === 0) {
      texte += motDizaine + (dizaine === 8 && terminal ? 's' : '');
    } else if (unite === 1 && dizaine !== 8) {
      texte += `${motDizaine} et un`;
    } else {
      texte += `${motDizaine}-${motUnite}`;
    }
  }
  return texte;
}

function nombreEnLettres(n: number): string {
  if (n === 0) return 'zéro';

  const tranches: [number, string][] = [
    [1_000_000_000, 'milliard'],
    [1_000_000, 'million'],
    [1_000, 'mille'],
  ];

  let reste = n;
  const parties: string[] = [];

  for (const [valeur, mot] of tranches) {
    const compte = Math.floor(reste / valeur);
    if (compte > 0) {
      const prefixe = valeur === 1000 && compte === 1 ? '' : `${centaineEnLettres(compte, false)} `;
      const pluriel = compte > 1 && valeur !== 1000 ? 's' : '';
      parties.push(`${prefixe}${mot}${pluriel}`.trim());
      reste %= valeur;
    }
  }

  if (reste > 0 || parties.length === 0) {
    parties.push(centaineEnLettres(reste));
  }

  return parties.join(' ').trim();
}
